module.exports = __webpack_public_path__ + "static/media/email.397b7cd2.png";